/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const RockingChair = createLucideIcon("rocking-chair", [
  ["path", { d: "m15 13 3.708 7.416", key: "1edxn9" }],
  ["path", { d: "M3 19a15 15 0 0 0 18 0", key: "d0d1c4" }],
  ["path", { d: "m3 2 3.21 9.633A2 2 0 0 0 8.109 13H18", key: "tpa4et" }],
  ["path", { d: "m9 13-3.708 7.416", key: "1oplxx" }]
]);

export { RockingChair as default };
//# sourceMappingURL=rocking-chair.js.map
